// Only logs in dev mode
export function devLog(message: unknown, ...optionalParams: unknown[]): void {
    if (process.env.NODE_ENV === 'development') {
      console.log(message, ...optionalParams);
    }
  }
  